<template>
  <v-text-field
    v-model="dataView"
    :active="showDatePicker"
    :focused="showDatePicker"
    :rules="props.rules"
    readonly
    v-bind="props.textField"
  >
    <v-dialog v-model="showDatePicker" activator="parent" width="auto">
      <v-card class="datepicker-container">
        <template v-if="$slots.default">
          <slot :data="data" :props="props.dateTimePicker"></slot>
        </template>
        <template v-else>
          <VueCtkDateTimePicker
            v-model="data"
            :inline="true"
            v-bind="props.dateTimePicker"
          />
        </template>
      </v-card>
    </v-dialog>
  </v-text-field>
</template>
<script lang="ts" setup>
import { computed } from 'vue'
import { VTextField } from 'vuetify/lib/components/index.mjs'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'

const data = defineModel({ required: true, default: '' })

interface Props {
  textField: VTextField['$props']
  dateTimePicker: any
  rules?: ((value: any) => boolean | string)[]
  formatText?: (value: string) => string
}

const props = defineProps<Props>()

const dataView = computed({
  get: () => {
    if (!props.formatText) {
      if (props.dateTimePicker?.range == true) {
        if (
          `${data.value?.start}${data.value?.end ? ` até ${data.value?.end}` : ''}` !=
          'undefined'
        ) {
          return `${data.value?.start}${data.value?.end ? ` até ${data.value?.end}` : ''}`
        }
        return ''
      }
      return data.value
    }
    if (props.dateTimePicker?.range == true) {
      if (
        `${props.formatText(data.value?.start)}${data.value?.end ? ` até ${props.formatText(data.value?.end)}` : ''}` !=
        'undefined'
      ) {
        return `${props.formatText(data.value?.start)}${data.value?.end ? ` até ${props.formatText(data.value?.end)}` : ''}`
      }
      return ''
    }
    return props.formatText(data.value)
  },
  set: (value) => {
    data.value = value || ''
  },
})

const showDatePicker = defineModel<boolean>('show', {
  required: false,
  default: false,
})
</script>